import { validateGameContentSnapshot, type GameContentSnapshot } from '../game/content/GameContentContracts';
import { exhibitionMatchFlow } from '../game/rules/MatchFlowDefinition';
import { validateMatchDefinition, type MatchDefinition, type VehicleDefinition } from '../game/world/MatchDefinition';
import type { RoomParticipant, RoomWelcome } from './roomProtocol';

export function roomVehicles(
  participants: readonly RoomParticipant[],
  snapshot: GameContentSnapshot,
): readonly VehicleDefinition[] {
  return participants.filter((participant) => participant.role === 'player' && participant.entityId !== null).map((participant) => {
    if (participant.team === null) throw new Error('Room vehicle has no team.');
    if (participant.kind === 'bot' && !participant.botId) throw new Error('Room bot has no policy identifier.');
    return {
      entityId: participant.entityId!,
      displayName: participant.displayName,
      team: participant.team,
      controller: participant.kind === 'bot'
        ? { kind: 'bot' as const, botId: participant.botId! }
        : { kind: 'human' as const },
      presentation: snapshot.vehiclePresentations[participant.team],
    };
  });
}

export function buildOnlineMatchDefinition(welcome: RoomWelcome): MatchDefinition {
  const snapshot = welcome.room.snapshot;
  validateGameContentSnapshot(snapshot);
  const definition: MatchDefinition = {
    authority: 'server',
    localEntityId: welcome.localEntityId,
    vehicles: roomVehicles(welcome.room.participants, snapshot),
    ballPresentation: snapshot.ballPresentation,
    arenaPresentation: snapshot.arenaPresentation,
    teamPresentation: snapshot.teamPresentation,
    effects: snapshot.effects,
    starterGoalExplosionLoadout: snapshot.starterGoalExplosionLoadout,
    audio: snapshot.audio,
    flow: exhibitionMatchFlow(),
    physics: { unlimitedBoost: false },
    training: null,
  };
  validateMatchDefinition(definition);
  return definition;
}
